import { useAuth } from "@/contexts/AuthContext";
import { useImpersonation } from "@/contexts/ImpersonationContext";

export function useEffectiveUserId() {
  const { user } = useAuth();
  const { activeCustomerId, isImpersonating } = useImpersonation();

  return {
    userId: isImpersonating ? activeCustomerId : user?.id ?? null,
    isImpersonating,
    realUserId: user?.id ?? null,
  };
}
